window.slate = window.slate || {};
window.theme = window.theme || {};

;(function (global, $) {
    //es5 strict mode
    "use strict";

    var search = ['utm_campaign', 'utm_content', 'utm_source', 'utm_medium', 'utm_term'];
    var params = querystring.parse();
    var utms = {};
    var found = false;

    for (var key in params) {
        if ($.inArray(key, search) > -1) {
            utms[key] = params[key];
            found = true;
        }
    }

    if (found) {
        if (Cookies.get('utm_values')) Cookies.remove('utm_values');
        Cookies.set('utm_values', utms, {expires: 1});
    }
  
     // Do we have anything already?
    if (Cookies.get('utm_values')) {
        var cookieVal = Cookies.get('utm_values');
        if (cookieVal) {
            utms = JSON.parse(Cookies.get('utm_values'));
        }

        // Change the donate btn
        var donateBtn = document.getElementById('donatebtn');
        var donateUrl = donateBtn.href.split('?')[0];
        if (donateUrl) {
            donateUrl += '?' + querystring.stringify(utms);
            donateUrl += '&amount=150';
            donateBtn.href = donateUrl;
        }
    }
  

}(window, jQuery));

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 *
   * @namespace product
 */

theme.Cart = (function() {

  /**
   * Cart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Cart(container) {
    this.$container = $(container);
    this.$employerBlock = this.$container.find('.employer');
    this.dynamicPids = this.getAllDynamicPids();

    this.updateCartTotal(Shopify.cart);

    this.$container.find('.js-dhp-block').on('change', this.DynamicHiddenProductTrigger.bind(this));
    this.$container.find('.js-dhp-block').on('click', this.DynamicHiddenProductTriggerClicked.bind(this));
    this.$container.find('.js-item-qty').on('change keypress', this.updateQtyTotal.bind(this));
    this.$container.find('.checkout-submit').on('click', this.validateEmployer.bind(this));

    this.$employerBlock.on('change', this.changeEmployerRadio.bind(this));

    if (Cookies.get('utm_values')) {
      var utms = JSON.parse(Cookies.get('utm_values'));

      for (var utmKey in utms) {
        jQuery('.employer').append('<input name="attributes[' + utmKey + ']" value="" id="' + utmKey + '" type="hidden" />');
        jQuery('#' + utmKey).val(utms[utmKey]);
      }
    }

  }

  Cart.prototype = $.extend({}, Cart.prototype, {

    // Code inside

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    validateEmployer: function(evt) {
      if (this.$container.find('.js-occupation-radio:checked').val() == 'other') {
        if ($.trim(this.$container.find('.js-occupation-input').val()) == false) {
            alert("Please enter your occupation.\n\n*Required by Federal Law for Political Contributions");
            return false;
        }
        if ($.trim(this.$container.find('.js-employer-input').val()) == false) {
            alert("Please enter your employer name.\n\n*Required by Federal Law for Political Contributions");
            return false;
        }
      }
    },

    updateQtyTotal: function(evt) {
      var input = $(evt.target);
      var qty = input.val();
      if (qty > 50) {
        input.val(50);
        qty = 50;
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {quantity: qty, id: input.data('id')},
        dataType: 'json',
        success: function(cart) {
          this.updateCartTotal(cart)
        }.bind(this)
      });
    },

    updateCartTotal: function(cart) {
      if (!cart.total_price) return;

      this.$container.find('.cart_total').html(slate.Currency.formatMoney(cart.total_price, theme.moneyFormat));

      // calculate the subtotal & item count
      var subtotal = 0;
      var totalItems = 0;
      for (var i = cart.items.length - 1; i >= 0; i--) {
        if ($.inArray(cart.items[i].id, this.dynamicPids) > -1) continue;

        subtotal += cart.items[i].line_price;
        totalItems += cart.items[i].quantity;
      }

      this.$container.find('.js-cart-subtotal').html(slate.Currency.formatMoney(subtotal, theme.moneyFormat));
      this.$container.find('.js-cart-totalitems').html(totalItems);

      if (totalItems == 0) {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          data: {},
          dataType: 'json',
          success: function(cart) {
            location.href = '/cart';
          }
        });
      }
    },

    changeEmployerRadio: function(evt) {
      var val = this.$employerBlock.find('.js-occupation-radio:checked').val();

      if (val == 'other') {
        this.$employerBlock.find('.js-occupation-input').removeAttr('disabled');
        this.$employerBlock.find('.js-employerblock-name').show();
        this.$employerBlock.find('.js-employer-input').attr('value', '');
      } else {
        this.$employerBlock.find('.js-occupation-input').attr('disabled', 'disabled');
        this.$employerBlock.find('.js-employerblock-name').hide();
        this.$employerBlock.find('.js-employer-input').attr('value', val);
      }
    },

    getAllDynamicPids: function() {
      var pids = [];

      this.$container.find('.js-dhp-block').each(function() {
        pids.push($(this).data('pid'));
      })

      return pids;
    },

    DynamicHiddenProductTrigger: function(evt){
      var block = $(evt.delegateTarget);
      var data = block.data();
      var selected = block.find('input:checked');

      if (selected.length) {
        this.DynamicHiddenProductSet(data.pid, selected.val(), data.cartattr);
      } else {
        this.DynamicHiddenProductRemove(data.pid, data.cartattr);
      }
    },

    DynamicHiddenProductTriggerClicked: function(evt) {
      var forAttr = $(evt.target).attr('for');
      var radio = $('#' + forAttr);

      if (radio.prop('checked')) {
        setTimeout(function(){
          radio.prop('checked', false).trigger('change');
        }, 200);
      }
    },

    DynamicHiddenProductSet: function(pid, qty, cartAttr) {
      var data = {updates: {}, attributes: {}};
      data.updates[pid] = qty;
      data.attributes[cartAttr] = true;

      this.DynamicHiddenProductSend(data);
    },

    DynamicHiddenProductRemove: function(pid, cartAttr) {
      var data = {updates: {}, attributes: {}};
      data.updates[pid] = 0;
      data.attributes[cartAttr] = '';

      this.DynamicHiddenProductSend(data);
    },

    DynamicHiddenProductSend: function(data) {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(cart) {
          this.updateCartTotal(cart)
        }.bind(this)
      });
    },

  });

  return Cart;
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 *
   * @namespace product
 */

theme.Collection = (function() {

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);
    this.$productFilter = this.$container.find('.product-feed-filter');

    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    this.$productFilter.find('select').val(this.$productFilter.data('current'))
    .bind('change', function(evt) {
      Shopify.queryParams.sort_by = jQuery(evt.target).val();
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    // Code inside

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },



  });

  return Collection;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    var sectionId = this.$container.attr('data-section-id');

    this.$container.find(".images-gallery").slick({
      arrows: false,
      infinite: true,
      autoplay: false,
      speed: 1000,
      pauseOnHover: false,
      adaptiveHeight: true,
      fade: true,
      cssEase: 'linear',
      dots: true,
      customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data('thumb');
        return '<a class="images-thumb"><img src="'+thumb+'"></a>';
      }
    });

    $('.sizing-info, .size-chart-link').click(function(){
      $('.sizing-window').addClass('is-visible');
      $('body').addClass('overflow-hidden');
    });

    $('.close-sizing').click(function(){
      $('.sizing-window').removeClass('is-visible');
      $('body').removeClass('overflow-hidden');
    });

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {

        /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.settings = {};
      this.namespace = '.product';
      this.variants = new slate.Variants(options);
      this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

      if (this.$featuredImage.length > 0) {
        this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

        this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * SliderFullWidth Template Script
 * ------------------------------------------------------------------------------
 *
   * @namespace product
 */

theme.SliderFullWidth = (function() {

  /**
   * SliderFullWidth section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function SliderFullWidth(container) {
    this.$container = $(container);
    this.$container.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 1500
    });
    this.$container.find('.open-popup-video').on('click', this.openPopupVideo.bind(this));
  }

  SliderFullWidth.prototype = $.extend({}, SliderFullWidth.prototype, {

    // Code inside

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    openPopupVideo: function(evt) {
      evt.preventDefault();
      var $btn = $(evt.target);
      var $vidOverlay = $('#video-overlay');

      $('body,html').addClass('overflow-hidden');
      $vidOverlay.addClass('on').removeClass('exiting').css('z-index','99999');
      $vidOverlay.find('.vid').html('<iframe id="frame" width="100%" height="600" src="https://www.youtube.com/embed/' + $btn.data('vid') + '?&amp;rel=0&amp;fs=0&amp;showinfo=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>');

      $vidOverlay.find('.close').on('click', function(){
        $vidOverlay.removeClass('on').addClass('exiting').css('z-index', '0');
        $vidOverlay.find('.vid').empty();
        $('body,html').removeClass('overflow-hidden');
      });
    }
  });

  return SliderFullWidth;
})();


/*================ Modules ================*/
;(function (global, $) {
    //es5 strict mode
    "use strict";

    $(document).ready(function() {
        $('.open-product-quickview').on('click', openQuickView);

        $('.close-product').click(function(){
            $('.product-quickview').removeClass('is-visible')
            .find('script').remove();

            $('body').removeClass('overflow-hidden');

            // wait for the close animation to finish
            setTimeout(function(){
                $('.product-quickview').find('.images-gallery').slick('unslick');
            }, 500);
        });
    });

    function openQuickView(evt) {
        evt.preventDefault();

        var currentTarget = $(evt.currentTarget);
        var qvelem = $('.product-quickview').addClass('is-visible');
        var jsonObj = $.parseJSON( currentTarget.closest('.product').find('.js-quickview-json').html() );
        $('body').addClass('overflow-hidden');

        var product = jsonObj.product;
        var options =  jsonObj.options;

        qvelem.find('[data-product-title]').html(product.title);
        qvelem.find('[data-product-url]').attr('href', currentTarget.data('product_url'));

        // Price
        if (product.compare_at_price > product.price) {
            qvelem.find('[data-product-price]').addClass('is-on-sale').html(slate.Currency.formatMoney(product.price, theme.moneyFormat) + '<strike>' + slate.Currency.formatMoney(product.compare_at_price, theme.moneyFormat) + '</strike>') ;
        } else {
            qvelem.find('[data-product-price]').removeClass('is-on-sale').html(slate.Currency.formatMoney(product.price, theme.moneyFormat));
        }

        // Images
        var galleryHtml = '';
        for (var i = 0; i < product.images.length; i++) {
            var imgUrl = slate.Image.getSizedImageUrl(product.images[i], '450x');
            galleryHtml += '<div class="slide" data-thumb="' + imgUrl + '"><img src="' + imgUrl + '"><a href="' + imgUrl + '" class="zoom icon"><span class="icon"></span></a></div>';
        }
        qvelem.find('.images-gallery').html(galleryHtml);

        // Options
        var optionsHtml = '';
        for (var i = 0; i < options.length; i++) {
            var optionNameLower = options[i].name.toLowerCase();
            var display = '';

            if (options[i].name == 'Title' && options[i].values.length == 1 && options[i].values[0] == 'Default Title') {
                display = 'style="display:none"';
            }

            if (optionNameLower.indexOf('size') !== -1) {
                optionsHtml += '<div class="row size" '+display+'>';
                optionsHtml += '<p>Select Your Size</p>';
            } else {
                optionsHtml += '<div class="row size" '+display+'>';
                optionsHtml += '<p>' + options[i].name + '</p>';
            }

            for (var ii = 0; ii < options[i].values.length; ii++) {
                var val = options[i].values[ii];

                optionsHtml += '<div class="col col-6">';
                optionsHtml +=     '<input type="radio" value="'+val+'" name="option-' + optionNameLower + '" id="option-'+optionNameLower+'-'+ii+'" data-index="option'+(i+1)+'" data-single-option-selector>';
                optionsHtml +=     '<label for="option-'+optionNameLower+'-'+ii+'">' + val + '</label>';
                optionsHtml += '</div>';
            }

            optionsHtml += '<span class="clear"></span>';
            optionsHtml += '</div>';
        }

        qvelem.find('.js-product-options').html(optionsHtml);

        // Variants
        var variantHtml = '';
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];

            variantHtml += '<option ';
            if (!variant.available) variantHtml += 'disabled="disabled"'
            variantHtml += ' value="'+ variant.id +'">';
            variantHtml += variant.title;
            variantHtml += '</option>';
        }

        qvelem.find('[data-product-select]').html(variantHtml);
        qvelem.append('<script type="application/json" data-product-json>' + JSON.stringify(jsonObj.product) + '</script>');

        var sections = new slate.Sections();
        sections.register('product', theme.Product);

        qvelem.find('[data-single-option-selector]:first').click();
    }

}(window, jQuery));
;(function (global, $) {
    //es5 strict mode
    "use strict";

    var gatePopup;

    $(document).ready(function() {
        //return false; //disabled for now;

        gatePopup = $('.gate-popup');
        if (gatePopup.length == 0) return false;
        if (document.referrer.indexOf(document.location.hostname) == -1) return false;
        //console.log('Show Gate Popup');

        // Show the gatepopup
        if (!Cookies.get('gate-email')) {
            gatePopup.removeClass('is-hidden');
            $('body, html').addClass('overflow-hidden');
        }

        gatePopup.find('.gate-popup-close').on('click', closeGate);
        gatePopup.find('form').on('submit', submitGate);
    });

    function closeGate(evt) {
        evt.preventDefault();

        gatePopup.addClass('is-hidden');
        $('body, html').removeClass('overflow-hidden');
        Cookies.set('gate-email', 'yes', {expires: $(evt.target).data('cookie_exp')});
    }

    function submitGate(evt) {
        evt.preventDefault();
        var btnText = gatePopup.find('.btn').val();
        gatePopup.find('.btn').addClass('btn-disabled').attr({'disabled':'disabled', 'value': 'wait..'});

        var data = $(this).find(':input').serializeArray();
        data.push({name: 'ref', value: window.location.toString()});

        $.post(gatePopup.find('form').attr('action'), data, function(rdata){
            gatePopup.find('.btn').removeClass('btn-disabled').removeAttr('disabled').attr('value', btnText);

            if (!rdata.success) {
                alert(rdata.error);
            } else {
                Cookies.set('gate-email', 'yes', {expires: 30});
                gatePopup.addClass('gate-thank-you');
                gatePopup.find('.box-form').addClass('is-hidden');
                gatePopup.find('.box-success').removeClass('is-hidden');

                if (rdata.dupe) {
                    gatePopup.find('.box-success').find('h3.large').hide();
                }
            }
        }, 'json');
    }

}(window, jQuery));

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('cart', theme.Cart);
  sections.register('collection', theme.Collection);
  sections.register('product', theme.Product);
  sections.register('slider-full-width', theme.SliderFullWidth);

  $('.select2').select2();

  mobileMenu();
  changeHeaderClass();
  select();

  $('.header-search').click(function(){
    $('.search-popup').addClass('is-visible');
    $('body').addClass('overflow-hidden');
    setTimeout(function(){
      $('#keywords').focus();
    }, 500);
  });
  $('.close-search').click(function(){
    $('.search-popup').removeClass('is-visible');
    $('body').removeClass('overflow-hidden');
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

});

$(window).resize(function() {
  changeHeaderClass();
});



/* Mobile Menu */
function mobileMenu() {
  var mobileMenuBtn = $('#mobile-menu-trigger');
  var mobileAccordian = $('.dropdown-trigger');
  var mobileDropIcon = $('.trigger-icon');
  mobileMenuBtn.click(function(){
    $(this).stop().toggleClass('is-open')
    $('body').stop().toggleClass('overflow-hidden');
    $('#header').stop().toggleClass('is-mobile-open');
    if($(this).hasClass('is-open')) {
      $('body').on('touchmove', false);
    } else  {
      $('body').off('touchmove', false);
    }
  })
  mobileAccordian.click(function(e){
    if ($("#mobile-menu-trigger").css("display") == "block" ){
      e.preventDefault();
      var dropdownMenu = $(this).attr('data-dropdown');
      var dropdownMenuID = '#' + dropdownMenu
      var triggerIcon = $(this).attr('data-icon');
      $('#' + dropdownMenu).stop().slideToggle();
      $('#' + triggerIcon).stop().toggleClass('is-active');
      $('.level-1-trigger').not(this).parent('.has-dropdown').find('.dropdown-menu').slideUp();
      $('.level-1-trigger').not(this).parent('.has-dropdown').find('.trigger-icon').removeClass('is-active');
    }
  })
}
/* Header Classes */
function changeHeaderClass(){
  if ($("#mobile-menu-trigger").css("display") == "block" ){
    $('body').removeClass('is-header-desktop');
    $('body').addClass('is-header-mobile');
  } else {
    $('body').removeClass('is-header-mobile');
    $('body').addClass('is-header-desktop');
  }
}
/* Select 2 */
function select(){
  $('.select-2').select2({
    minimumResultsForSearch: Infinity
  });
}